import React from 'react';

type Props = {
  currentShowList: any,
  formStep: number,
  formIsValid: boolean,
  loadingStep: boolean,
  errorMessage: string | null,
}

function ShowSmsFormSubmit({
  currentShowList,
  formStep,
  formIsValid,
  loadingStep,
  errorMessage,
} : Props) {
  if (formStep === 1) {
    return (
      <button
        type="submit"
        className={
                `${formIsValid
                  ? 'bg-chdBlue text-white font-bold shadow-md cursor-pointer '
                  : 'bg-gray-300 text-black cursor-default'
                } p-2 tracking-wider rounded-sm w-[155px] uppercase block`
              }
        disabled={!formIsValid}
      >
        {loadingStep && 'Submitting data...'}
        {!errorMessage && !loadingStep && 'Submit'}
        {errorMessage && 'Error occurred. Restart?'}
        {errorMessage && <p className="text-[#ff0000]">{errorMessage}</p>}
      </button>
    );
  } if (formStep > 1) {
    return (
      <div className="flex flex-col items-center m-auto text-center text-black">
        <button
          type="submit"
          className="bg-chdBlue text-white font-bold shadow-md cursor-pointer p-2 tracking-wider rounded-sm w-[155px] uppercase block mb-10"
        >
          Done!
        </button>
        {currentShowList.length > 0 && (
        <>
          <h3 className="mb-2 text-2xl font-bold">Thanks for Signing Up!</h3>
          <p>You will now receive show reminders for:</p>
          <ul className="my-4">
            {currentShowList.map((show) => (
              <li key={show} className="font-bold text-darkCyan">
                {show}
              </li>
            ))}
          </ul>
        </>
        )}
        {currentShowList.length === 0 && <p className="font-bold text-darkCyan">You were unsubscribed from all CHD.TV alerts.</p>}
      </div>
    );
  }
}

export default ShowSmsFormSubmit;
